import { Component } from 'react'
import api from '../services/api'
import { useAuth } from '../contexts/AuthContextRedux'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.logError(error, errorInfo)
  }

  async logError(error, errorInfo) {
    try {
      await api.post('/log', {
        message: error.toString(),
        stack: errorInfo.componentStack,
        userId: this.props.userId,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
      })
    } catch (logError) {
      console.error('Failed to log error:', logError)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="card w-96 bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title text-error">Something went wrong</h2>
              <p>We've encountered an unexpected error. Please refresh the page.</p>
              <div className="card-actions justify-end">
                <button 
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export function ErrorLogger({ children }) {
  const { user } = useAuth()
  
  return (
    <ErrorBoundary userId={user?.id}>
      {children}
    </ErrorBoundary>
  )
}

// Utility function to log errors
export async function logError(message, context = {}) {
  try {
    await api.post('/log', {
      message,
      context,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    })
  } catch (error) {
    console.error('Failed to log error:', error)
  }
}